<script setup lang="ts">
import { cn } from '@/lib/utils'
import { SelectScrollUpButton, type SelectScrollUpButtonProps } from 'radix-vue'
import { computed, type HTMLAttributes } from 'vue'

const props = defineProps<SelectScrollUpButtonProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props
  return delegated
})
</script>

<template>
  <SelectScrollUpButton
    v-bind="delegatedProps"
    :class="cn('flex cursor-default items-center justify-center py-1', props.class)"
  >
    <slot>
      <Icon name="lucide:chevron-up" class="size-4" />
    </slot>
  </SelectScrollUpButton>
</template>
